import { useState } from "react";
import type { SupportReportAnchor } from "@compliance-sage/contracts";
import { Button } from "../../components/ui";
import { useI18n } from "../../i18n";
import type { MsgKey } from "../../i18n";
import { ReportResultDialog } from "./ReportResultDialog";

/**
 * The affordance that sits next to an AI result. Deliberately small and
 * repeated per result rather than hoisted into the page chrome: what makes a
 * report worth acting on is which result it names, and clicking next to that
 * result is the only way a reporter can say so without describing it.
 *
 * Permission gating is the caller's job — every mount site already resolves
 * `can("SUPPORT_CREATE")`, and this component is rendered inside trees that do
 * not all have an auth provider.
 */
export function ReportResultButton({
  anchor,
  reviewId,
  findingId,
  checklistReferenceId,
  subject,
  anchorLabel,
  labelKey = "reportThisResult",
}: {
  anchor: SupportReportAnchor;
  reviewId: string;
  findingId?: string;
  checklistReferenceId?: string;
  subject: string;
  anchorLabel?: string;
  labelKey?: MsgKey;
}) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" className="px-0 text-xs" onClick={() => setOpen(true)}>
        {t(labelKey)}
      </Button>
      {open && (
        <ReportResultDialog
          open
          onClose={() => setOpen(false)}
          anchor={anchor}
          reviewId={reviewId}
          findingId={findingId}
          checklistReferenceId={checklistReferenceId}
          subject={subject}
          anchorLabel={anchorLabel}
        />
      )}
    </>
  );
}
